<a href='/'>
    <img
    [ngSrc]="getLogoSrc()"
    width="250"
    height="250"
    alt="Logo"
    [class]="getLogoSize()"
    priority
   />
</a>
